import { lightRoot } from '../../theme/logisticsTheme';

export default function PageShell({ children, className = '' }) {
  return (
    <div
      className={`min-h-full rounded-2xl p-4 sm:p-6 lg:p-8 ${className}`.trim()}
      style={lightRoot}
    >
      {children}
    </div>
  );
}
